export default "__VITE_ASSET__8a2ea925__"